import { cx } from '@emotion/css';
import { memo } from 'react';

interface ConversationTagProps {
  text: string;
  className?: HTMLDivElement['className'];
}

export const ConversationTag = memo((props: ConversationTagProps) => {
  const { text, className } = props;
  return (
    <div
      className={cx([
        'h-[18px] px-1 leading-[18px] rounded-sm text-fill-0 text-xs max-w-28 text-ellipsis overflow-hidden whitespace-nowrap',
        className,
      ])}
      title={text}
    >
      {text}
    </div>
  );
});
